import { render, staticRenderFns } from "./BusinessIntelligence.vue?vue&type=template&id=b8c2b2e0&scoped=true&"
import script from "./BusinessIntelligence.vue?vue&type=script&lang=js&"
export * from "./BusinessIntelligence.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&id=b8c2b2e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c2b2e0",
  null
  
)

export default component.exports